/*eslint-disable */
import {
  bus
} from '../../main';
import appFooter from '../../components/footer/index';
import welcome from '../../components/welcome-popup/index';
import toast from '../../services/toast';
var $ = window.jQuery = require('jquery');
export default {
  name: 'forgot-password',
  components: {
    'app-footer': appFooter,
    'welcome-popup': welcome
  },
  props: [],
  data() {
    return {
      email: ''
    }
  },
  computed: {

  },
  mounted() {
    bus.$emit('showHomeMenuBtn', true);
    bus.$emit('showQuizMenubtn', true);
    if (process.env.NODE_ENV == 'production') {
      this.$scriptLoader.load("https://www.googletagmanager.com/gtag/js?id=UA-152519411-1")
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-152519411-1');
    }
    if(localStorage.getItem('Reset_Email')){
      this.email = localStorage.getItem('Reset_Email')
    }else{
      this.email = ''
    }
  },
  methods: {
    validateBeforeForgotPasswordSubmit() {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            email: this.email
          }
          this.$store.dispatch('forgotPasswordFun', data)
            .then((response) => {
              if (response.status == 200) {
                toast.success(response.data.msg);
                localStorage.getItem('Reset_Email', this.email)
                this.$router.push('/login/');
              }
            }).catch(function(err) {})
          return
        }
      })
    }
  },
  beforeCreate: function() {
    $('body').addClass('public-routes');
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('public-routes');
    next();
  },
}